module.exports = __webpack_public_path__ + "img/pencil.db604e90.svg";